import { Megaphone } from 'lucide-react';
import { AccountKpiStrip } from './components/AccountKpiStrip';
import { CampaignFiltersBar } from './components/CampaignFiltersBar';
import { CampaignTable } from './components/CampaignTable';

export function CampaignsAccountView() {
  return (
    <div className="space-y-5">
      <header className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Megaphone size={20} className="text-indigo-500" />
          <div>
            <div className="text-[10px] font-mono uppercase text-slate-400">
              Performance
            </div>
            <h1 className="text-lg font-bold text-navy-900">Campaigns</h1>
          </div>
        </div>
        <p className="text-xs text-slate-500 max-w-md text-right">
          Cross-channel campaign performance for your connected ad accounts.
        </p>
      </header>

      <CampaignFiltersBar />
      <AccountKpiStrip />
      <CampaignTable />
    </div>
  );
}

export default CampaignsAccountView;
